module.exports = __webpack_public_path__ + "static/media/MyCPDMain.d687bf7c.png";